export default "__VITE_ASSET__EHsSZc0p__"